import React from "react";
import {MultiselectElementProps} from "@data-force/app";
import {message, Select} from "antd";
import {OptionProps} from "antd/lib/select";
import "../DynamicForm.scss";
import {connect} from "react-redux";
import {SPACE_KEY} from "../../../utils/constants";
import {clearAlerts} from "../../../store/actions/layout";
import {ClearAlertsAction} from "../../../interfaces/store/actions/layout";

interface DispatchProps {
    clearAlerts(): ClearAlertsAction
}

export type Props = MultiselectElementProps & DispatchProps;

type SelectionOption = string | number;

class MultiselectElement extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.getPopupContainer = this.getPopupContainer.bind(this);
    }

    onChangeHandler(value: string[] | number[]): void {
        const {
            fieldName, index, refElements, onSave,
        }: MultiselectElementProps = this.props;
        this.props.onChange({
            fieldName, value, index, refElements,
        });

        if (onSave) {
            onSave({
                fieldName,
                index,
                changeValue: value,
            });
        }
        message.destroy();
        this.props.clearAlerts();
    }

    getPopupContainer(trigger: HTMLElement): HTMLElement {
        return trigger.parentNode as HTMLElement;
    }

    /**
     * Default SPACE_KEY behavior, causes page scroll and display of empty option list.
     *
     * @param {React.KeyboardEvent} event
     * @return {void}
     */
    handleKeyDown(event: React.KeyboardEvent): void {
        if (event.key === SPACE_KEY) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    render() {
        const {
            elementKey, value, allowedValues, className = "", isStringType, readOnly,
        }: MultiselectElementProps = this.props;
        const multiValue: string[] | number[] = isStringType ? value as string[] : value as number[];
        const options: SelectionOption[] = allowedValues || [];

        return (
            <Select
                className={className}
                value={multiValue}
                mode="multiple"
                onChange={this.onChangeHandler}
                disabled={readOnly}
                onKeyDown={this.handleKeyDown}
                getPopupContainer={this.getPopupContainer}
            >
                {
                    options.map((allowedValue: string | number, optionIndex: number)
                    : React.ReactElement<OptionProps> => (
                        <Select.Option
                            key={`${elementKey}-${optionIndex}-${allowedValue}`}
                            value={allowedValue}
                        >
                            {allowedValue}
                        </Select.Option>
                    ))
                }
            </Select>
        );
    }
}

const mapDispatchToProps: DispatchProps = {
    clearAlerts,
};

export default connect(null, mapDispatchToProps)(MultiselectElement);
